import { useState } from "react";
import BlockConfirmModal from "./BlockConfirmModal";
import { blockUser, unblockUser } from "../../api/block";
import "./styles/BlockButton.scss";

const BLOCK_FAILED = "ブロック処理に失敗しました";
const UNBLOCK_FAILED = "ブロック解除に失敗しました";

// 400 はサーバの message、それ以外は固定文言（HTML などを画面に出さない）
const toErrorMessage = (res, fallback) =>
  res?.status === 400 &&
  typeof res?.data?.message === "string" &&
  res.data.message
    ? res.data.message
    : fallback;

const BlockButton = ({
  targetUserId,
  userName,
  isBlocked,
  onBlocked,
  onUnblocked,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const [statusMessage, setStatusMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const mode = isBlocked ? "unblock" : "block";

  const openModal = () => {
    setError(null);
    setStatusMessage(null);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setError(null);
  };

  const handleConfirm = async () => {
    if (isSubmitting) return;
    setError(null);
    setIsSubmitting(true);
    const fallback = isBlocked ? UNBLOCK_FAILED : BLOCK_FAILED;
    try {
      const res = isBlocked
        ? await unblockUser(targetUserId)
        : await blockUser(targetUserId);
      const status = res?.status;
      if (status >= 200 && status < 300) {
        setShowModal(false);
        if (isBlocked) {
          setStatusMessage("ブロックを解除しました");
          onUnblocked?.(targetUserId);
        } else {
          setStatusMessage("ブロックしました");
          onBlocked?.(targetUserId);
        }
      } else {
        setError(toErrorMessage(res, fallback));
      }
    } catch {
      setError(fallback);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="blockButton">
      <button
        type="button"
        className={`blockButton__btn${isBlocked ? " blockButton__btn--unblock" : ""}`}
        onClick={openModal}
      >
        {isBlocked ? "ブロックを解除する" : "ブロックする"}
      </button>
      {statusMessage && (
        <p className="blockButton__status" role="status">
          {statusMessage}
        </p>
      )}
      <BlockConfirmModal
        isOpen={showModal}
        onClose={closeModal}
        onConfirm={handleConfirm}
        userName={userName || ""}
        mode={mode}
        errorMessage={error}
      />
    </div>
  );
};

export default BlockButton;
